import { LineupSchedule, LineupScheduleBlock } from './../../../interfaces/lineup';
import { LineupService } from '../../../services/lineup.service';
import { TranslateService } from '@ngx-translate/core';
import { Component, forwardRef, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
	selector: 'bb-week-time-grid',
	templateUrl: './bb-week-time-grid.component.html',
	styleUrls: ['./bb-week-time-grid.component.scss'],
	providers: [{
		provide: NG_VALUE_ACCESSOR,
		useExisting: forwardRef(() => BbWeekTimeGridComponent),
		multi: true
	}]

})

export class BbWeekTimeGridComponent implements ControlValueAccessor, OnInit, OnChanges {
	schedule: LineupSchedule;

	el: HTMLElement;
	valueOnlyModel = false;
	secondsInBlock = 24 * 60 * 60;

	weekdays = [
		{ label: this.translate.instant('MONDAY'), value: 'monday' },
		{ label: this.translate.instant('TUESDAY'), value: 'tuesday' },
		{ label: this.translate.instant('WEDNESDAY'), value: 'wednesday' },
		{ label: this.translate.instant('THURSDAY'), value: 'thursday' },
		{ label: this.translate.instant('FRIDAY'), value: 'friday' },
		{ label: this.translate.instant('SATURDAY'), value: 'saturday' },
		{ label: this.translate.instant('SUNDAY'), value: 'sunday' },
	];

	hourMarkers = [0, 4, 8, 12, 16, 20, 24];
	gaps: any[] = [];
	activeCycle: {
		d: number;
		c: number;
	} = null;

	constructor(
		private translate: TranslateService,
		private lineupService: LineupService
	) {
	}

	ngOnInit() {
		// console.warn('schedule', this.schedule);
	}

	ngOnChanges(changes: SimpleChanges) {

	}

	clearAll() {
		this.schedule = {
			blocks: [{
				cycles: []
			},
			{
				cycles: []
			},
			{
				cycles: []
			},
			{
				cycles: []
			},
			{
				cycles: []
			},
			{
				cycles: []
			},
			{
				cycles: []
			}]
		};
		this.propagate();
	}

	getWeekDay(dayNr: number) {
		const d = new Date(0);
		d.setDate(dayNr + 5);
		return d.toLocaleString(window.navigator.language, { weekday: 'short' });
	}

	addCycle(blockIndex, fromTo?) {
		const block = this.schedule.blocks[blockIndex];
		fromTo = fromTo || {
			from: 0,
			to: (24 * 60 * 60)
		};
		block.cycles.push({
			label: 'New cycle',
			items: [],
			from: fromTo.from,
			to: fromTo.to,
			loopTimeSeconds: 600,
			justAdded: true
		});
		this.update();
		const cycleIndex = block.cycles.findIndex(cycle => {
			const ret = cycle.justAdded;
			if (ret) {
				delete cycle.justAdded;
			}
			return ret;
		});
		this.activeCycle = {
			d: blockIndex,
			c: cycleIndex
		};
		this.propagate();
	}

	onCycleDeleted(block: LineupScheduleBlock, cycleIndex) {
		block.cycles.splice(cycleIndex, 1);
		this.activeCycle = null;
		this.propagate();
	}

	log(a) {
		console.warn('log', a);
	}

	onCycleClick(blockIndex, cycleIndex) {
		if (this.activeCycle && this.activeCycle.d === blockIndex && this.activeCycle.c === cycleIndex) {
			this.activeCycle = null;
		} else {
			this.activeCycle = {
				d: blockIndex,
				c: cycleIndex
			};
		}
	}

	propagate() {
		this.update();
		this.propagateChange(this.schedule);
	}

	update() {
		this.gaps = this.lineupService.getAllGaps(this.schedule);
	}

	// ControlValueAccessor functions:

	writeValue(value: any) {
		this.schedule = value;
		this.activeCycle = null;
		this.update();
	}

	registerOnChange(fn: any) {
		this.propagateChange = fn;
	}

	registerOnTouched() {

	}

	propagateChange(_: any) { }
}
